import { ref, onBeforeUnmount } from '@nuxtjs/composition-api'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

function subscribeTo(observable, next, error, complete) {
  const unsubscribe$ = new Subject()
  const subscription = observable
    .pipe(takeUntil(unsubscribe$))
    .subscribe(next, error, complete)
  onBeforeUnmount(() => {
    unsubscribe$.next()
    unsubscribe$.complete()
  })
  return subscription
}
export function useObservable(observable, defaultValue) {
  const handler = ref(defaultValue)
  subscribeTo(
    observable,
    value => {
      handler.value = value
    },
    error => {
      throw error
    }
  )
  return handler
}
export function useSubscription(observable, next, error, complete) {
  return subscribeTo(observable, next, error, complete)
}
export function useDOMEvent() {
  const subject = new Subject()
  return {
    subject,
    callback: event => {
      subject.next(event)
    }
  }
}
